import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';
import { formatterCurrencyTruncated } from '@/utilities/format';
import { useId } from 'react';

type Props = {
  lastSharePrice: number | null;
  fairValue: number;
  currencyIso: string;
  npvPerShare: number | null;
};

export const NarrativeMiniValuatorPriceDiscount = ({
  lastSharePrice,
  fairValue,
  currencyIso,
  npvPerShare,
}: Props) => {
  const currentPriceLabelId = useId();
  return (
    <div className="grid gap-x0_25">
      <div className="text-tiny text-soft" id={currentPriceLabelId}>
        Current Price
      </div>
      <div
        className="grid h-x4 grid-cols-[max-content_auto] items-center gap-x0_5"
        role="status"
        aria-live="polite"
        aria-labelledby={currentPriceLabelId}
      >
        <span className="text-sm text-solid">
          {lastSharePrice
            ? formatterCurrencyTruncated(lastSharePrice, currencyIso, 2)
            : 'N/A'}
        </span>
        <span className="text-tiny">
          <CompanyIntrinsicDiscount
            fairValue={fairValue}
            lastSharePrice={lastSharePrice}
            npvPerShare={npvPerShare}
          />
        </span>
      </div>
    </div>
  );
};
